import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import MainComponent from "./MainComponent";
import { useNavigate } from "react-router-dom";
import Example from "./BICard.js";
import {
  biDetailsList,
  getDashboardTaskDetails,
  postAddBiRoles,
  postBiRolePermissions,
} from "../store/actions/index.js";
import Add from "../assets/images/add.svg";
import { createStatus } from "./gtmExecution/WorkboardProgress";
import Login from "./Login.js";
import { motion } from "motion/react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";


function Dashboard() {
  const username = localStorage.getItem("full_name");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isBIFetched = useSelector((state) => state.isBIFetched);
  const biDetails = useSelector((state) => state.biDetails);
  const [biData, setBiData] = useState([]);
  const fetchDashboardTaskData = useSelector(
    (state) => state.fetchDashboardTaskData
  );
  const [isnewBiButtonDisabled, setIsNewBiButtonDisabled] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const uiListDetails = useSelector((state) => state.uiListDetails);
  const isUIListFetched = useSelector((state) => state.isUIListFetched);

  const BiRolesAdded =  useSelector((state) => state.fetchPostAddBiRoles);


  const handleSelect = () => {
    

    dispatch(postAddBiRoles());

    
  };


  useEffect(() => {
    if (BiRolesAdded) {
      localStorage.removeItem("bi_id");
      localStorage.setItem("newbuttonClicked", JSON.stringify(true));
      window.location.href = "/bidetails";
    }
  }, [BiRolesAdded]);


  useEffect(() => {
    dispatch(biDetailsList());
    dispatch(getDashboardTaskDetails());
    return () => {};
  }, []);
  useEffect(() => {
    if (isUIListFetched) {
      if (uiListDetails) {
        if (uiListDetails.data) {
          if (uiListDetails.data.message) {
            const data = uiListDetails.data.message[0].filter(
              (each) => each.title === "Dashboard"
            );
            const isdisabled =
              data.length > 0 ? data[0].disable_new_bi_button : null;
            setIsNewBiButtonDisabled(isdisabled);
          }
        }
      }
    }
  }, [isUIListFetched]);

  useEffect(() => {
    if (isBIFetched) {
      if (biDetails && biDetails?.data) {
        setBiData(biDetails.data.bi_data);
      }
    }
  }, [isBIFetched, biDetails]);

  useEffect(() => {
    if (
      fetchDashboardTaskData &&
      fetchDashboardTaskData.task_data &&
      fetchDashboardTaskData.task_data.length > 0
    ) {
      setTaskList(fetchDashboardTaskData.task_data);
    }
  }, [fetchDashboardTaskData]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 60,
      renderCell: (params) => <div>{params.value}</div>,
    },
    {
      field: "name",
      headerName: "Task Name",
      width: 500,
      renderCell: (params) => (
        <div
          onClick={(e) => handleCellClick(e, params)}
          style={{
            textDecoration: "underline",
            color: "blue",
            cursor: "pointer",
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "bi_name",
      headerName: "BI name",
      headerAlign: "left",
      align: "left",
      width: 250,
      renderCell: (params) => <div>{params.value}</div>,
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <div style={{ marginLeft: "0px", paddingLeft: "0px" }}>
          {createStatus(params.value)}
        </div>
      ),
    },
    {
      field: "exp_end_date",
      headerName: "Due Date",
      width: 150,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => <div>{params.value}</div>,
    },
  ];
  const content = (
    <motion.div
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      <div
        style={{
          fontSize: "var(--main-heading)",
          fontWeight: "var(--heading-font-weight)",
        }}
      >
        Hi {username} <span>&#x21; &#128075;</span>
      </div>
      {!isnewBiButtonDisabled && (
        <>
          <div style={{ fontSize: "var(--sub-heading-font-size)" }}>
            Welcome to your Dashboard. Start by creating your first Business
            Initiative
          </div>
          <div
            className=""
            style={{
              border: "thin solid",
              borderStyle: "ridge",
              borderRadius: "10px",
              height: "65vh",
              textAlign: "center",
              paddingBottom: 20,
            }}
          >
            <div
              style={{
                marginTop: "20%",
                fontSize: "var(--main-heading)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              New Business Initiative
            </div>
            <p>Accelerate your growth by oboarding your Inititaive.</p>
            <Button
              onClick={handleSelect}
              style={{
                backgroundColor: "#0A5F59",
                text: "center",
                width: 150,
                height: 43,
                border: "1px solid var(--rs-border-primary)",
              }}
            >
              Create New BI
            </Button>
          </div>
        </>
      )}
    </motion.div>
  );
  const handleCellClick = (e, data) => {
    if (data && data.row) {
      localStorage.setItem("workboard_filter", 2);
      localStorage.setItem("bi_id", data.row.bi_id);
      localStorage.setItem("product_id", data.row.product_id);
      localStorage.setItem("selectedfunction", data.row.function_id);
      const params = new URLSearchParams({
        bi_id: data.row.bi_id,
        product_id: data.row.product_id,
        function_id: data.row.function_id,
        task_id: data.row.task_id,
        parent_task_id: data.row.parent_task_id,
      });
      // navigate(`/workboard?${params.toString()}`);
      // window.location.reload();
      const navigation_url = `/workboard?${params.toString()}`;

      dispatch({ type: "SET_SELECTED_BI", payload: { value: data.row.bi_id } });
      dispatch(postBiRolePermissions(data.row.bi_id, navigation_url));
    }
  };
  const data =
    taskList &&
    taskList.map((item, index) => ({
      ...item,
      id: index + 1,
    }));
  var bi_content = (
    <motion.div
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
      style={{ width: "100%", overflow: "hidden" }}
    >
      <div
        style={{
          fontSize: "var(--main-heading)",
          fontWeight: "var(--heading-font-weight)",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          Hi {username} <span>&#x21; &#128075;</span>
        </div>
        <div>
          {!isnewBiButtonDisabled && (
            <div>
              <button
                style={{
                  width: "fit-content",
                  padding:'10px 15px',
                  background: "white",
                  border: "1px solid #EAEAEA",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={handleSelect}
              >
                <img
                  alt="logo"
                  src={Add}
                  width={16}
                  height={16}
                  style={{ marginRight: "5px" }}
                ></img>
                <span style={{ fontSize: "var(--text-font-size)" }}>
                  New BI
                </span>
              </button>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          fontSize: "var(--sub-heading-font-size)",
          marginBottom: "20px",
        }}
      >
        Here's what is happening in your organisation today.
      </div>
      <div style={{ display: "flex", width: "100%", height: "95%" }}>
        <div
          style={{
            width: "100%",
            height: "95%",
            paddingRight: 10,
          }}
        >
          <div
            style={{
              width: "100%",
            }}
          >
            <Example cardContents={biData} />
            <hr style={{ borderBottom: "1px solid #000", borderTop: 0 }} />
          </div>
          <div>
            <div
              style={{
                fontSize: "var(--main-heading)",
                fontWeight: "var(--heading-font-weight)",
                paddingBottom: "10px",
              }}
            >
              My Tasks
            </div>
            {taskList && taskList.length > 0 ? (
              <div>
                <div style={{ width: "100%", height: "50vh" }}>
                  <DataGrid
                    rows={data}
                    columns={columns}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 100,
                        },
                      },
                    }}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      },
                    }}
                    disableColumnSelector
                    disableDensitySelector
                    disableRowSelectionOnClick
                  />
                </div>
              </div>
            ) : (
              <>
                <h5
                  style={{
                    paddingTop: "50px",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  There are no tasks to show
                </h5>
              </>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <>
        <MainComponent
          maincontent={biData.length > 0 ? bi_content : content}
          showSideBar={false}
          breadcrumbs={"Dashboard"}
          showTemplate={true}
          showFullScreen={true}
        />
      </>
    );
  }
}

export default Dashboard;
